module.exports = __webpack_public_path__ + "static/media/clocktime.2c993b55.svg";